<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue';

defineProps({
    detailsColumn: Array,
    detailsRow: Array,
    pagination: Object,
});

const emit = defineEmits(['update:pagination']);

const onRequest = (props) => {
    emit('update:pagination', props);
};
</script>

<template>
    <div class="bg-white p-6 rounded-lg border border-gray-200">
        <div class="flex justify-between items-center mb-4">
            <h4 class="text-lg font-semibold text-gray-800">Payment Details</h4>
        </div>
        <div class="overflow-x-auto">
            <q-table :rows="detailsRow" :columns="detailsColumn" row-key="name" class="my-sticky-header-table" flat
                bordered binary-state-sort :pagination="pagination" @request="onRequest">
                <template v-slot:header="props">
                    <q-tr :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props" class="!text-[16px]">
                            {{ col.label }}
                        </q-th>
                    </q-tr>
                </template>
                <template v-slot:body-cell-username="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-full text-[15px] font-medium">
                            {{ props.row.username }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-gameweek="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-full text-[15px] font-normal">
                            {{ props.row.gameweek }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-paymentType="props">
                    <q-td :props="props">
                        <span class="px-3 py-1 rounded-full text-[13px] font-medium" :class="{
                            'text-[#7c3aed] bg-purple-200': props.row.paymentType === 'Stripe',
                            'text-blue-900 bg-blue-200': props.row.paymentType === 'Postal'
                        }">
                            <q-icon :name="props.row.paymentType === 'Stripe' ? 'credit_card' : 'mail'"
                                class="mr-2 mb-1" size="18px" />
                            <span>
                                {{ props.row.paymentType }}
                            </span>
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-amount="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-full text-[15px] font-medium">
                            {{ props.row.amount }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-status="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-lg text-xs font-medium" :class="{
                            'bg-green-100 text-green-700': props.row.status === 'Paid',
                            'bg-red-100 text-red-700': props.row.status === 'Failed',
                            'bg-yellow-100 text-yellow-700': props.row.status === 'Pending'
                        }">
                            {{ props.row.status }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-transactionId="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-full text-[15px] font-normal text-gray-500">
                            {{ props.row.transactionId }}
                        </span>
                    </q-td>
                </template>
                <template v-slot:body-cell-date="props">
                    <q-td :props="props">
                        <span class="px-2 py-1 rounded-full text-[15px] font-normal">
                            {{ props.row.date }}
                        </span>
                    </q-td>
                </template>
            </q-table>

        </div>
    </div>
</template>

<style>
.q-table__top,
.q-table__bottom,
thead {
    background-color: #F9FAFB;
}

thead {
    font-size: 20px;
}
</style>